import { FormInstance } from "antd";
import { UploadFile, UploadFileStatus } from "antd/es/upload/interface";


export interface CustomUploadFile extends UploadFile<any> {
    binary?: File;
}

export const validateUploadFiles = (form: FormInstance) => {
    return (_: any, value: any) => {
        // Allow existing files without validation
        if (value && value.length > 0 && value.every((file: CustomUploadFile) => file.url)) {
            return Promise.resolve();
        }

        // If no files are uploaded, skip validation
        if (!value || value.length === 0) {
            return Promise.resolve(); // No files uploaded, so no validation needed
        }

        for (let file of value) {
            if (!["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(file.type)) {
                return Promise.reject(new Error("Invalid file type. Please upload a file of type png, jpg or webp."));
            }
            if (file.size > 1024 * 1024) {
                return Promise.reject(new Error("File size must be less than 1MB."));
            }
        }

        const blobs = Array.from(value).map((file: any) => {
            return new Blob([file], { type: file.type });
        });
        form.setFieldsValue({ files: blobs });
        return Promise.resolve();
    };
};

export const imageUploadAccept = '.jpeg,.jpg,.png,.webp';